import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/** Organic's heavier icon stroke (docs/design/organic/organic-readme.md,
 * "Icons") — Lucide has no global default, so pass this to every icon
 * explicitly: `<Check strokeWidth={ICON_STROKE_WIDTH} />`. */
export const ICON_STROKE_WIDTH = 2.75;
